<template>
    <div style="background: #fff;">
        <van-nav-bar
                title="ICCID-短号绑定"
        />
        <div style="padding: 20px">
            <ul class="card-list">
                <li class="card-item">
                    <div style="text-align: left;min-width: 40px">序号</div>
                    <div style="width: 100%;display: flex;text-align: center">
                        <div style="width: 100%;text-align: left"> ICCID</div>
                        <div style="width: 100%;text-align: right">短号</div>
                    </div>
                    <div style="width: 20%;text-align: right">操作</div>
                </li>
                <li class="card-item"  v-for="(item,index) in iccid">
                    <div style="text-align: left;min-width: 40px">{{index+1}}</div>
                    <div style="width: 100%;display: flex;">
                        <div style="width: 100%;text-align: left"> {{item}}</div>
                        <div style="width: 100%;color: #3a8ee6;text-align: right">{{short_number[index]}}</div>
                    </div>
                    <div class="del" style="width: 20%;text-align: right" @click="remove(index)">删除</div>
                </li>
            </ul>


            <van-row>
                <van-cell>
                    <div  v-if="wxReady==true">
                    <van-button type="primary" @click="handleScan" block icon="qr">扫码</van-button>
                    <p  style="font-size: 14px;color: #ff5257;line-height: 20px;text-align: center">请先扫码条码，再扫描二维码</p>
                    </div>
                    <p v-else style="font-size: 14px;color: #ff5257;line-height: 100px;text-align: center;">请等待扫码组件加载完成</p>
                </van-cell>
                <van-cell>
                    <van-button type="info" v-if="iccid.length > 0" @click="handleSubmit" block icon="upgrade">提交绑定
                    </van-button>
                </van-cell>
            </van-row>
        </div>
    </div>
</template>

<script>
    import wx from "weixin-js-sdk";
    export default {
        name: "productBind",
        data() {
            return {
                wxReady: true,
                iccid: [],
                short_number: [],
            };
        },
        methods: {
            initWechatJs() {
                let url = encodeURIComponent(location.href.split('#')[0])
                this.fetchData('/wechat/jssdk', {url: url}, (res) => {
                    if (res.code) {
                        wx.config(res.data);
                        wx.ready(() => {
                            this.wxReady = true;
                        })
                    }
                })
            },
            handleScan() {
                if (!this.wxReady) {
                    this.$toast.fail('扫码控件初始化失败')
                    return false;
                }
                wx.scanQRCode({
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    success: (res) => {
                        let result = res.resultStr;
                        let iccid=''
                        if (result.indexOf('http') != -1) {
                            //地址二维码
                            const regexp = /(iccid|no)\=([\da-zA-Z]{1,})/
                            if (regexp.test(result) == false) {
                                this.$toast.fail('无法识别的二维码')
                                return false;
                            }
                            iccid = result.match(regexp)[2]

                        } else if (result.indexOf(',') != -1) {
                            //设备条码
                            let iccidarr = result.split(',');
                            iccid = iccidarr[1] ? iccidarr[1] : result;
                        } else {
                            iccid = res.resultStr
                        }
                        if (!iccid || iccid == undefined) {
                            this.$toast.fail('无法识别的二维码/条码')
                            return false;
                        }
                        if (iccid.length <= 10) {
                            this.short_number.push(iccid)
                        } else {
                            this.iccid.push(iccid)
                        }

                    }
                });
            },
            remove(index) {
                this.iccid.splice(index, 1)
                this.short_number.splice(index, 1)
            },
            handleSubmit() {
                if (this.iccid.length == 0) {
                    this.$toast.fail('请先扫码录入');
                    return false;
                }
                if (this.iccid.length != this.short_number.length) {
                    this.$toast.fail('设备号与短号数量不一致');
                    return false;
                }
                this.$toast.loading('提交中')
                this.fetchDataPost('/base/iccidShortNumberBind', {
                    iccid: this.iccid,
                    short_number: this.short_number
                }, res => {
                    this.$toast.clear();
                    if (res.code) {
                        this.$toast.success(res.msg)
                        setTimeout(()=>{
                            this.iccid = []
                            this.short_number = []
                        },2000)
                    } else {
                        this.$toast.fail(res.msg);
                    }

                })

            },
            cardLength(A, B) {
                A = A.replace(/[^\d]/g, '', A);
                B = B.replace(/[^\d]/g, '', B);
                let result = [];
                (A += ''), (B += '');
                while (A[0] === '0') {
                    A = A.substr(1);
                }
                while (B[0] === '0') {
                    B = B.substr(1);
                }
                const l = -5;
                let N = '1';
                for (let i = 0; i < -l; i++) {
                    N += '0';
                }
                N = parseInt(N);
                while (A !== '' && B !== '') {
                    result.unshift(parseInt(A.substr(l)) - parseInt(B.substr(l)));
                    A = A.slice(0, l);
                    B = B.slice(0, l);
                }
                if (A !== '' || B !== '') {
                    let s = B === '' ? 1 : -1;
                    A += B;
                    while (A !== '') {
                        result.unshift(s * parseInt(A.substr(l)));
                        A = A.slice(0, l);
                    }
                }
                while (result.length !== 0 && result[0] === 0) {
                    result.shift();
                }
                let s = '';
                if (result.length === 0) {
                    result = 0;
                } else if (result[0] < 0) {
                    s = '-';
                    for (let i = result.length - 1; i > 0; i--) {
                        if (result[i] > 0) {
                            result[i] -= N;
                            result[i - 1]++;
                        }
                        result[i] *= -1;
                        result[i] += '';
                        while (result[i].length < -l) {
                            result[i] = '0' + result[i];
                        }
                    }
                    result[0] *= -1;
                } else {
                    for (let i = result.length - 1; i > 0; i--) {
                        if (result[i] < 0) {
                            result[i] += N;
                            result[i - 1]--;
                        }
                        result[i] += '';
                        while (result[i].length < -l) {
                            result[i] = '0' + result[i];
                        }
                    }
                }

                if (result) {
                    while ((result[0] = parseInt(result[0])) === 0) {
                        result.shift();
                    }
                    result = s + result.join('');
                }
                result = parseInt(result);
                if (result >= 0) result++
                if (result < 0) result--;
                return result
            }
        },
        created: function () {
            this.initWechatJs()
        }
    };
</script>
<style lang="scss">
    .card-item{
        padding: 10px 0;
        display: flex;
        font-size: 15px;
        .del{
            color: #ff5257;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/productBind.vue